import { render, staticRenderFns } from "./HomeFeatureBoxes.vue?vue&type=template&id=b1c0b674&scoped=true&"
import script from "./HomeFeatureBoxes.vue?vue&type=script&lang=js&"
export * from "./HomeFeatureBoxes.vue?vue&type=script&lang=js&"
import style0 from "./HomeFeatureBoxes.vue?vue&type=style&index=0&id=b1c0b674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c0b674",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow})
